async function getFotfDetails(email) {
  const response = await $.ajax({
    url: `https://${aws}/autopilot/getdetails.php?e=${encodeURIComponent(
      email
    )}&c=?`,
    dataType: 'jsonp',
  });

  return {
    success: response?.response?.response?.Success === 'true',
    response: response?.response?.response,
  };
}

async function submitFotfForm(formData, etAction) {
  const dataObj = Object.fromEntries(formData.entries());

  const response = await $.ajax({
    type: 'POST',
    url: `http://apps.harrisfarm.com.au/fotf/register.php?action=${etAction}`,
    data: dataObj,
    cache: false,
    dataType: 'jsonp',
    contentType: 'application/json',
  });

  return {
    success: response?.result === true,
    response: response || '',
    custbarcode: response?.custbarcode || '',
  };
}

async function subscribeToKlaviyo(formData) {
  let statusCode = 0;
  let mobileNo = formatMobileNo(formData.get('mobileno'));
  let smsSubscribe = formData.get('sms_opt_in') === 'yes';
  let custBarcode = formData.get('custbarcode');
  let custBarcodeUrl = `https://apps.harrisfarm.com.au/images/barcodes/${custBarcode}.jpg`;

  const response = await $.ajax({
    type: 'POST',
    url: 'https://a.klaviyo.com/client/subscriptions?company_id=Xbyprx',
    headers: {
      accept: 'application/vnd.api+json',
      'content-type': 'application/vnd.api+json',
      revision: '2025-07-15',
    },
    data: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: formData.get('email'),
                phone_number: mobileNo,
                first_name: formData.get('firstname'),
                last_name: formData.get('lastname'),
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                  ...(smsSubscribe && {
                    sms: { marketing: { consent: 'SUBSCRIBED' } },
                  }),
                },
                properties: {
                  Zip: formData.get('postcode'),
                  CustomerSubCategoryCode: formData.get('storename'),
                  CustomerBarcodeURL: custBarcodeUrl,
                },
              },
            },
          },
          custom_source: 'Friends of the Farm',
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'TU4jyM',
            },
          },
        },
      },
    }),
    complete: (jqXHR) => {
      statusCode = jqXHR.status;
    },
  });

  return {
    success: statusCode === 202,
    response,
  };
}

function formatMobileNo(mobileNo) {
  if (!mobileNo) return null;
  return mobileNo.startsWith('0') ? '+61' + mobileNo.slice(1) : mobileNo;
}
